import React from 'react';
import { useState, useEffect } from 'react';
import Blog from "../Blog/Blog"
import './Blogs.css'

const Blogs = () => {
    const [blogs, setBlogs] = useState([])

    useEffect(() => {
        fetch("./blogs.json")
            .then(res => res.json())
            .then(data => setBlogs(data))
    }, [])
    console.log(blogs);
    return (
        <div id="blog" style={{ background: "#2B3443" }} className="py-5 pb-5 blog-section">
            <div className="container">
                <h1 className="text-center text-white pb-4 section-border">Blogs</h1>
                <div className="row row-cols-1 row-cols-md-3 g-4 pb-5">
                    {
                        blogs.map(blog => <Blog
                            key={blog.id}
                            blog={blog}
                        ></Blog>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Blogs;